



























































































































import { Component, Vue, Watch, Emit } from 'vue-property-decorator';
import SettingDirectoryModal from '@/components/documents/SettingDirectoryModal.vue';
import DocumentIcon from '@/components/documents/DocumentIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';

@Component({
  components: {
    SettingDirectoryModal,
    DocumentIcon,
    CommonButton,
  },
})
export default class DirectoryMenuNavigationDrawer extends Vue {
  private isOpenSettingDirectoryModal: boolean = false;
  private drawer: boolean = true;
  private mini: boolean = false;
  private documentAvatarSize: number = 30;
  private documentAvatarColor: string = '#4384f3';
  private documentIconSize: number = 15;
  private documentIconColor: string = 'white';
  private documentAvatarSizeShrink: number = 30;
  private documentAvatarColorShrink: string = '#4384f3';
  private documentIconSizeShrink: number = 15;
  private documentIconColorShrink: string = 'white';
  private addPageCommonButtonColor: string = '#4384f3';

  private openSettingDirectoryModal(): void {
    this.isOpenSettingDirectoryModal = true;
  }

  private closeSettingDirectoryModal(): void {
    this.isOpenSettingDirectoryModal = false;
  }

  private selection = [];
  @Watch('selection', {deep: true, immediate: true})
  private selected() {
    return this.$emit('selectDocument', this.selection[0].parent, this.selection[0].name)
  }

  private documents = [
    {
      id: 1,
      name: '通話アプリ開発',
      children: [
        {id: 2, name: 'API設計書', parent: '通話アプリ開発'},
        {id: 3, name: 'テーブル定義書', parent: '通話アプリ開発'},
        {id: 4, name: 'UI画面設計', parent: '通話アプリ開発'},
        {id: 5, name: 'サービス定義書', parent: '通話アプリ開発'}
      ],
    },
    {
      id: 6,
      name: 'マッチングアプリ開発',
      children: [
        {id: 7, name: '進捗管理表', parent: 'マッチングアプリ開発'},
        {id: 8, name: '説明資料パワポ', parent: 'マッチングアプリ開発'},
      ],
    },
  ]
}
